import { Button, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useThemeContext } from '../../../contexts/BaseThemeContextProvider';

const BorderedButton = ({
  onClick,
  buttonText,
  isLoading,
  additionalProps,
  sxProps = {},
  variant = 'outlined',
  to = '',
}) => {
  const [loading, setLoading] = useState(false);
  const { theme } = useThemeContext();

  const defaultSxProps = {
    borderRadius: '24px',
    textTransform: 'none',
    padding: '8px 24px',
    color: theme.buttons.ghost.color,
    border: '2px solid',
    borderColor: theme.buttons.ghost.borderColor,
    backgroundColor: 'transparent',
    '&:hover': {
      background: 'transparent',
      color: theme.buttons.ghost.hover.color,
      borderColor: theme.buttons.ghost.hover.borderColor,
      border: '2px solid',
    },
  };

  useEffect(() => {
    setLoading(isLoading);
  }, [isLoading]);

  if (to) {
    return (
      <Button
        variant={variant}
        to={to}
        component={Link}
        disabled={loading}
        sx={{
          ...defaultSxProps,
          ...sxProps,
        }}
        {...additionalProps}
      >
        {loading ? <CircularProgress size={24} color="inherit" /> : buttonText}
      </Button>
    );
  } else {
    return (
      <Button
        variant={variant}
        onClick={onClick}
        disabled={loading}
        sx={{
          ...defaultSxProps,
          ...sxProps,
        }}
        {...additionalProps}
      >
        {loading ? <CircularProgress size={24} color="inherit" /> : buttonText}
      </Button>
    );
  }
};

BorderedButton.propTypes = {
  onClick: PropTypes.func,
  buttonText: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  additionalProps: PropTypes.object,
  variant: PropTypes.oneOf(['text', 'outlined', 'contained']),
  to: PropTypes.string,
};

export default BorderedButton;
